import { useQuery } from "@tanstack/react-query";
import { getWidgetConfig } from "@/services/v2/widgetService";

const useWidgetConfig = (widgetKey) =>
  useQuery({
    queryKey: ["widgetConfig", widgetKey],
    enabled: !!widgetKey,
    retry: false,
    staleTime: Infinity,
    queryFn: async () => {
      const res = await getWidgetConfig(widgetKey);
      if (!res || res.errorCode !== 0 || !res.result) {
        throw new Error("Widget unavailable");
      }
      return res.result;
    },
  });

export default useWidgetConfig;
